import React from 'react'

import { Text } from '@/components/common'
import { Column, Row, Section, Layout } from '@/components/layout'
import MailingListOptOutForm from '@/components/Pages/EmailPreferences/MailingListOptOutForm'
import MailingListOptInForm from '@/components/Pages/EmailPreferences/MailingListOptInForm'

const pageId = 'emailPreferences'

const getMessageId = id => `pages.${pageId}.${id}`

export default function EmailPreferencesPage() {
  return (
    <Layout.Content id={pageId} padded>
      <Section gap={16} paddingTop={16} responsive>
        <Row>
          <Text.H2 messageId={getMessageId('subscribe.header')} />
        </Row>
        <Row marginBottom={64}>
          <Column>
            <Text.P messageId={getMessageId('subscribe.p1')} noMargin />
            <Text.P messageId={getMessageId('subscribe.p2')} />
          </Column>
          <Column>
            <MailingListOptInForm />
          </Column>
        </Row>
        <Row>
          <Column fill={false} size={75}>
            <Text.P bold messageId={getMessageId('unsubscribe.header')} noMargin />
            <Text.P messageId={getMessageId('unsubscribe.p1')} />
            <MailingListOptOutForm />
          </Column>
        </Row>
      </Section>
    </Layout.Content>
  )
}

EmailPreferencesPage.layoutProps = {
  pageId,
}
